// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { StyleSheet } from "react-native";
import fonts from "../../config/fonts";
import colors from "../../config/colors";

const ComboBoxStyle = StyleSheet.create({
  container: {
    borderColor: colors.green,
    borderRadius: 8,
    width: "95%",
    marginLeft: "20%",
  },
  label: {
    fontWeight: "bold",
    marginRight: 5,
    color: colors.green,
    fontFamily: fonts.regular,
  },
  pickerContainer: {
    flex: 1,
    overflow: "hidden",
    backgroundColor: colors.green,
    borderRadius: 8,
    borderColor: colors.green,
    paddingHorizontal: 5,
    borderRadius: 8,
  },
  picker: {
    width: "100%",
    color: colors.white,
    borderColor: colors.green,
    fontWeight: "bold",
    fontSize: 16,
    backgroundColor: colors.green,
    borderRadius: 8,
    fontFamily: fonts.regular
  },
  pickerItem: {
    fontWeight: "bold",
    fontFamily: fonts.regular
  },
});

export default ComboBoxStyle;
